import { render, staticRenderFns } from "./controlRoomBattery.vue?vue&type=template&id=3180a5f5&scoped=true&"
import script from "./controlRoomBattery.vue?vue&type=script&lang=js&"
export * from "./controlRoomBattery.vue?vue&type=script&lang=js&"
import style0 from "./controlRoomBattery.vue?vue&type=style&index=0&id=3180a5f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180a5f5",
  null
  
)

export default component.exports